export default __webpack_public_path__ + "static/media/3536 knife block A side.e394b8fd.png";